/* eslint no-param-reassign: ["error", { "props": false }] */
import http from '@/http';

import { deserialize } from '@/utils/json-api';

const SET_PROFILE = 'SET_PROFILE';

const defaultState = () => ({
  profile: undefined,
});

export default {
  namespaced: true,
  state: defaultState,
  getters: {
  },
  mutations: {
    [SET_PROFILE](state, { data }) {
      const { data: one } = deserialize(data);
      state.profile = one;
    },
  },
  actions: {
    async fetchProfile({ commit }) {
      try {
        const response = await http.get('profile');
        commit(SET_PROFILE, response);
        return response;
      } catch (e) {
        throw e;
      }
    },
  },
};
